import videojs from 'video.js';
import './count-down.js';
// import BlockingReason from '../../utils/BlockingReason.js';
import DRMErrorPage from '../../utils/DRMErrorPage.json';
import ERRORTYPE from '../../errors/errors.js';
import PlayerUtils from '../../utils/PlayerUtils.js';
import Utils from '../../utils/Utils.js';

const VJSErrorDisplay = videojs.getComponent('ErrorDisplay');
const Button = videojs.getComponent('Button');

/**
 * Improve original Error display component implemented the LetterBoxWeb
 * CSS skin and displayed specific error.
 * @ignore
 */
class ErrorDisplay extends VJSErrorDisplay {
  constructor(player, options) {
    const opt = videojs.mergeOptions(options, {
      pauseOnOpen: true,
      fillAlways: true,
      temporary: false,
      uncloseable: true,
    });

    super(player, opt);
  }

  description() {
    const error = this.player().error();

    return error && error.message;
  }

  close() {
    this.removeChild('countDown');
    super.close();
  }

  content() {
    const error = this.overrideVideoJSError(this.player().error());

    if (!error) { return null; }

    if (ERRORTYPE.ERROR_BLOCKING_REASON_STARTDATE.type === error.type) {
      return this.countDownEl();
    }

    const icon = videojs.dom.createEl('div', {
      className: `${error.iconClass || 'vjs-icon-error'} icon`,
      title: this.localize(error.message),
    });

    const text = videojs.dom.createEl('div', {
      className: 'text',
    },
    {},
    this.createHrefEl(error) || this.localize(error.message));

    const debugButton = this.createDebugButton();

    const element = videojs.dom.createEl('div', {
      className: 'content',
    },
    {},
    [icon, text, debugButton]);

    return element;
  }

  createDebugButton() {
    return new Button(this.player(), {
      name: 'debugButton',
      clickHandler([e]) {
        e.preventDefault();
        e.stopPropagation();
        const debugInfo = PlayerUtils.getDebugInformation(this.player());

        Utils.copyTextToClipboard(Utils.prettyStringify(debugInfo));
      },
      el: videojs.dom.createEl('button', {
        className: 'error__debug',
        innerText: this.localize('Copy debug info'),
      },
      {
        'aria-label': this.localize('Copy debug info'),
        role: 'button',
      }),
    }).el();
  }

  countDownEl() {
    const countDownView = this.addChild('countDown');
    const { mediaComposition } = this.player().options().SRGProviders;

    this.player().poster(mediaComposition.getMainChapterImageUrl());

    return countDownView.el();
  }

  createHrefEl(error) {
    if (error.hasLink) {
      const { vendor } = this.player().options().SRGProviders.mediaComposition.getMainChapter();
      const href = error.hasLink ? DRMErrorPage[vendor] : undefined;

      return videojs.dom.createEl('a', {
        className: 'error__href',
      }, {
        target: '_blank',
        href,
      }, this.localize(error.message));
    }
    return undefined;
  }

  overrideVideoJSError(error) {
    if (!error) {
      return undefined;
    }

    if (error.type) {
      return error;
    }

    const mergedError = videojs.mergeOptions(
      {},
      ERRORTYPE.ERROR_UNKNOWN,
      { detailedMessage: error.message },
    );

    this.player().error(mergedError);

    return this.player().error();
  }
}

videojs.registerComponent('ErrorDisplay', ErrorDisplay);
export default ErrorDisplay;
